/* eslint-disable brace-style */
import { fastlyUrl, imageProps, imageTypes, propsBuilder } from "./cdn-image-url";

const getImageFromPath = (obj, configUrl) => {
    if (typeof obj === "object" && obj !== null) {
        if (Array.isArray(obj)) {
            return obj.map(element => getImageFromPath(element, configUrl));
        }
        for (const key in obj) {
            if (key === "image") {
                obj[key] = fastlyUrl(configUrl, (obj[key] || "").replace("/", ""), imageTypes.gsCarCardAU);
            } else if (typeof obj[key] === "object") {
                getImageFromPath(obj[key], configUrl);
            }
        }
    }
    // Return the modified object or array
    return obj;
};

export const getFastlyImage = (config, path, imageConfig) => {
    return fastlyUrl(config.brandImageHost, (path || "").replace("/", ""), imageConfig || imageTypes.helloARCarCardAu);
};

export const getCmsFastlyImage = (url, imageConfig) => {
    return propsBuilder(url, imageProps[imageConfig].fastly);
};

export default getImageFromPath;
